/** @jsx jsx */
import React from "react";
import { jsx } from "@emotion/core";
export const Astronaut1 = React.forwardRef<
  SVGSVGElement,
  Omit<React.SVGProps<SVGSVGElement>, "css">
>((props, ref) => (
  <svg
    viewBox="0 0 132 132"
    ref={ref}
    css={{
      color: "#F4F6F8",
      height: "132px",
      width: "132px",
    }}
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <circle cx={66} cy={66} r={66} fill="currentColor" />
      <path
        fill="#CAD0D8"
        d="M89 24c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137zM17 67c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137zm68 43c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137zm32-53c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137z"
      />
      <circle cx={75.5} cy={13.5} r={1.5} fill="#CAD0D8" />
      <circle cx={35.5} cy={53.5} r={1.5} fill="#CAD0D8" />
      <circle cx={37.5} cy={15.5} r={1.5} fill="#CAD0D8" />
      <circle cx={109.5} cy={42.5} r={1.5} fill="#CAD0D8" />
      <circle cx={106.5} cy={75.5} r={1.5} fill="#CAD0D8" />
      <circle cx={62.5} cy={107.5} r={1.5} fill="#CAD0D8" />
      <circle cx={38.5} cy={111.5} r={1.5} fill="#CAD0D8" />
      <g transform="translate(21 36)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
      <g transform="translate(56 26)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
      <g transform="translate(27 90)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
      <g transform="translate(105 95)">
        <circle cx={2.5} cy={2.5} r={2.5} fill="#CAD0D8" />
        <circle cx={2.5} cy={2.5} r={1} fill="currentColor" />
      </g>
      <path
        fill="#F18686"
        d="M55.765 51.937l7.589-7.589a4.598 4.598 0 0 1 6.503-.002l1.654 1.652 11.807 11.825 1.576 1.576a5 5 0 0 1 0 7.07l-7.198 7.198-21.931-21.73z"
      />
      <path
        fill="currentColor"
        stroke="#464646"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M52.512 81.211l5.422-5.42a3.068 3.068 0 1 0-4.338-4.338l-5.42 5.422a3.068 3.068 0 0 1-4.336-.116 3.068 3.068 0 0 1-.002-4.216l9.758-9.758a3.07 3.07 0 0 1-4.336-4.349l6.505-6.499a6.133 6.133 0 0 1 8.675 0l13.01 13.01a6.133 6.133 0 0 1 0 8.675l-6.505 6.506a3.068 3.068 0 1 1-4.338-4.338l-9.758 9.758a3.065 3.065 0 1 1-4.336-4.336z"
      />
      <path
        stroke="#464646"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M53.596 62.78l5.422-5.421"
      />
      <path
        fill="currentColor"
        stroke="#464646"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M76.907 44.045a8.434 8.434 0 1 1-.001 16.868 8.434 8.434 0 0 1 0-16.868z"
      />
      <path
        stroke="#464646"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M72.029 70.37l-5.422 5.422M55.765 51.937l7.589-7.589a4.598 4.598 0 0 1 6.503-.002l.002.002 1.652 1.65m5.939 27.624l7.59-7.589a4.598 4.598 0 0 0 .001-6.503l-.002-.002-1.652-1.652"
      />
      <path
        fill="#74B0F4"
        stroke="#464646"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M65.163 61.335l2.891 2.891a1.023 1.023 0 0 1 0 1.446l-2.89 2.89a1.023 1.023 0 0 1-1.446 0l-2.891-2.89a1.023 1.023 0 0 1 0-1.446l2.89-2.89a1.02 1.02 0 0 1 1.446 0z"
      />
      <path
        stroke="#464646"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M82.296 58.962a15.052 15.052 0 0 0-3.762-8.109 15.063 15.063 0 0 0-8.108-3.77m-9.505 34.394l1.163 1.337c6.539 7.505 17.922 8.288 25.427 1.752.501-.437.98-.901 1.43-1.392"
      />
    </g>
  </svg>
));
